import { CalendarIcon, UsersIcon } from "lucide-react";

import { Row, Text } from "@/components";

import { dates } from "@/lib/dates";
import { Job } from "@/types";

export const NumberOfCandidatesAndPublished = ({
  job,
  numberOfCandidates,
  sourced,
}: {
  job: Job;
  numberOfCandidates: number;
  sourced?: boolean;
}) => {
  const label = sourced ? "sourced candidate" : "candidate";

  return (
    <Row className="items-center gap-3 text-slate-500">
      <Row className="items-center gap-1.5">
        <UsersIcon className="h-4 w-4" />
        <Text variant="muted">
          {numberOfCandidates.toLocaleString()} {label}
          {numberOfCandidates !== 1 && "s"}
        </Text>
      </Row>
      <Text variant="muted" className="text-slate-300">
        ·
      </Text>
      <Row className="items-center gap-1.5">
        <CalendarIcon className="h-4 w-4" />
        <Text variant="muted">
          Published {dates.timeAgoForJob(job.createdAt)}
        </Text>
      </Row>
    </Row>
  );
};
